var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink01 = function SvgLink01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m7.617 8.91.172-.173a4.222 4.222 0 1 1 5.972 5.971l-2.389 2.389a4.222 4.222 0 1 1-5.971-5.972l.387-.387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m14.21 9.263.387-.387a4.222 4.222 0 1 0-5.972-5.971L6.237 5.293a4.222 4.222 0 1 0 5.971 5.972l.172-.173"
  })));
};
export default SvgLink01;